import React from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScriptsCallback } from '../../../helpers/Utils';

export function ClientsClientSetPage(): React.ReactElement {
  const currentSecurity = useSecurity('Clients', 'ClientSet');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(["Areas/Clients/Scripts/Resources/en/res.ClientSet.en.js",
        "Areas/Clients/Scripts/Resources/en/Types.en.js",
        "Areas/Clients/Scripts/Enums.js",
        "Areas/Clients/Scripts/ClientSet/Index.js"], "initClientsClientSet", {});
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}
